import { useLayoutEffect } from 'react';

export function useAdobeTrackingData(metaTitle: string, trackingAllowed: boolean) {
  useLayoutEffect(() => {
    const w = window as any;
    let dataTrackingDetails = document.querySelectorAll('a[data-tracking-id]');

    if (trackingAllowed) {
      dataTrackingDetails.forEach((el) => {
        if (!el.getAttribute('data-tracked')) {
          el.addEventListener('click', function () {
            w?._satellite?.track('custom event', {
              event: el.getAttribute('data-tracking-id'),
            });
            el.setAttribute('data-tracked', '');
          });
        }
      });
    }
  }, [metaTitle, trackingAllowed]);
}
